import React, { useState, useEffect } from "react";
import { displayFormatDate } from "../../utils/helpers";
import ShadowTeamMembersTable from "./ShadowTeamMembersTable";
import { ThreeDots } from "react-loader-spinner";
import { useEmployeeStore } from "../../stores/employeeListStore";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { getApi } from "../../utils/api";
import { API_GET_SHADOW_RESOURCE_PROJECT_DETAILS_BY_PROJECT_ID } from "../../config/Endpoints";
import { useMainEmployeeStore } from "../../stores/mainEmployeeListStore";
import { projectTypeOptions } from "../../options/projectTypesOptions";
const DisplayProjectDetails = ({ projectId, isOpen }) => {
  const accessToken = Cookies.get("accessToken");
  const [details, setDetails] = useState(null);
  const { employeeList, fetchEmployees } = useEmployeeStore();
  const { fetchMainEmployees } = useMainEmployeeStore();

  const getProjectTypeLabel = (value) => {
    const option = projectTypeOptions.find((opt) => opt.value === value);
    return option ? option.label : project?.projectType;
  };
  useEffect(() => {
    if (employeeList.length === 0) {
      fetchEmployees();
    }
  }, [employeeList.length, fetchEmployees]);

  useEffect(() => {
    if (isOpen) {
      fetchMainEmployees(projectId);
    }
  }, [isOpen, projectId]);

  useEffect(() => {
    if (!isOpen) return;

    const fetchDetails = async () => {
      try {
        const res = await getApi(
          `${API_GET_SHADOW_RESOURCE_PROJECT_DETAILS_BY_PROJECT_ID}/${projectId}`,
          accessToken
        );

        if (res.data.statusCode === 200) {
          setDetails(res.data.data);
        } else {
          toast.error(res.data.message || "Failed to fetch project details");
        }
      } catch (err) {
        toast.error(
          err.response?.data?.message ||
            "Something went wrong while fetching project details"
        );
      }
    };

    fetchDetails();
  }, [isOpen, projectId, accessToken]);

  const project = details;
  console.log(details);
  if (!details) {
    return (
      <div className="centered-loader">
        <ThreeDots
          height="60"
          width="60"
          radius="9"
          color="blue"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClassName=""
          visible={true}
        />
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="row mb-2 g-0 d-flex align-items-stretch">
          <div className="col-md-6 px-4 mt-2 d-flex flex-column project-details">
            {/* Project Name */}
            <div className="row p-2 mt-2 align-items-center">
              <label className="col-md-5 text-black-50 mb-2">
                Project Name
              </label>
              <div className="col-md-7 px-4 py-2 rounded-2 project-details-field ">
                {project.projectName}
              </div>
            </div>

            <div className="row p-2 align-items-center">
              <label className="col-md-5 text-black-50 mb-2">
                Project Type
              </label>
              <div className="col-md-7 px-4 py-2 rounded-2 project-details-field ">
                {getProjectTypeLabel(project.projectType)}
              </div>
            </div>
            {/* Delivery Lead */}
            <div className="row p-2 align-items-center">
              <label className="col-md-5 text-black-50 mb-2">
                Delivery Lead
              </label>
              <div className="col-md-7 px-4 py-2 rounded-2 project-details-field ">
                {project.dlName || "N/A"}
              </div>
            </div>

            {/* Project Manager */}
            <div className="row p-2 align-items-center">
              <label className="col-md-5 text-black-50 mb-2">
                Project Manager
              </label>
              <div className="col-md-7 px-4 py-2 rounded-2 project-details-field ">
                {project.pmName || "N/A"}
              </div>
            </div>

            {/* Principal Sponsor */}
            <div className="row p-2 align-items-center">
              <label className="col-md-5 text-black-50 mb-2">
                Principal Sponsor
              </label>
              <div className="col-md-7 px-4 py-2 rounded-2 project-details-field ">
                {project.psName || "N/A"}
              </div>
            </div>

            {/* Lead Business Analyst */}
            {project.lbaName && project.lbaName !== "N/A" && (
              <div className="row p-2 align-items-center">
                <div className="col-md-5 text-black-50 mb-2">
                  Lead Business Analyst
                </div>
                <div className="col-md-7 px-4 py-2 rounded-2 project-details-field ">
                  {project.lbaName}
                </div>
              </div>
            )}

            {/* SOW Dates */}
            <div className="row p-2 align-items-center">
              <label className="col-md-5 text-black-50 mb-2">SOW</label>
              <div className="col-md-7 d-flex gap-2 p-0">
                <div className="position-relative project-date-box">
                  <span className="m-0 dateBadgeStyle">Start Date</span>
                  <div className="py-3 px-2 rounded-2 text-center dateBoxStyle">
                    {project.sowStartDate
                      ? displayFormatDate(project.sowStartDate)
                      : "Ongoing"}
                  </div>
                </div>
                <div className="position-relative project-date-box">
                  <span className="m-0 dateBadgeStyle">End Date</span>
                  <div className="py-3 px-2 rounded-2 text-center dateBoxStyle">
                    {project.sowEndDate
                      ? displayFormatDate(project.sowEndDate)
                      : "Ongoing"}
                  </div>
                </div>
              </div>
            </div>

            {/* Actual Dates */}
            <div className="row p-2 align-items-center">
              <label className="col-md-5 text-black-50 mb-2">Actual</label>
              <div className="col-md-7 d-flex gap-2 p-0">
                <div className="position-relative project-date-box">
                  <span className="m-0 dateBadgeStyle">Start Date</span>
                  <div className="py-3 px-2 rounded-2 text-center dateBoxStyle">
                    {project.startDate
                      ? displayFormatDate(project.startDate)
                      : "Ongoing"}
                  </div>
                </div>
                <div className="position-relative project-date-box">
                  <span className="m-0 dateBadgeStyle">End Date</span>
                  <div className="py-3 px-2 rounded-2 text-center dateBoxStyle">
                    {project.endDate
                      ? displayFormatDate(project.endDate)
                      : "Ongoing"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right column: Description */}
          <div className="col-md-6 px-4 mt-2 d-flex flex-column project-details">
            <label className="px-4 mb-2 py-2 mt-3  text-black-50">
              Project Description
            </label>
            <div className="summary-content rounded-2 p-4 flex-grow-1 project-details-field-description-display project-details-field-description">
              {project.commercialSummary || "No description provided."}
            </div>
          </div>
        </div>
      </div>

      <ShadowTeamMembersTable project={project} />
    </div>
  );
};

export default DisplayProjectDetails;
